import * as React from "react"

const LineColor1 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                width={2}
                height={23}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 2 23`}


            >
                <path
                    id={"line-color-1"}

                    ref={pathRef}

                    d="M1 0v23"
                    fill="#F72585"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                />
            </svg>
        )
    }
)

export default LineColor1
